import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { presignedURLGet, downloadFolders } from '../services';
import { useNavbarContext } from 'context/NavbarContext';
import { uuidv4 } from 'common/uuidGenerator';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';

export default function useFileDownload() {
  const { downloadFile: downloadAs, addFolderDownload } = useNavbarContext();
  const location = useLocation();
  const { addToast } = useToast();

  const downloadFile = async (file, callback) => {
    let file_path = file?.file_path;
    let file_name = file?.display_name ? file?.display_name : location?.state?.case_details?.display_name;
    let version_id = file?.version_id;
    let file_sk = file?.sk;
    let file_pk = file?.pk;
    let data = await presignedURLGet(file_path, version_id, false, false, file_sk, file_pk);
    let url = data?.data?.file_url;
    downloadAs(url, file_name);

    if (callback && typeof callback === 'function') {
      callback();
    }
  };

  const downloadCertFile = async (file, callback) => {
    let file_path = file?.esignature_request?.cirtificate_url;
    let file_name = file?.display_name || file?.esignature_request?.request_name;
    let version_id = '';
    let data = await presignedURLGet(file_path, version_id);
    let url = data?.data?.file_url;
    downloadAs(url, file_name);

    if (callback && typeof callback === 'function') {
      callback();
    }
  };

  const downloadFolder = async (folder, caseId) => {
    try {
      const downloadId = uuidv4();
      const folderData = {
        id: downloadId,
        folderName: folder?.display_name,
        folderId: folder?.folder_id,
        caseId: caseId,
        status: 'In Progress',
        progress: 0,
        zipFile: null,
        error: null,
      };

      // Add to folder downloads context
      addFolderDownload(folderData);

      const requestData = {
        sk: folder?.sk,
        folder_name: folder?.display_name,
        case_id: caseId,
      };

      // folder download API
      const response = await downloadFolders(requestData);
    } catch (error) {
      console.error('Error downloading folder:', error);
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'Failed to initiate folder download.');
      addFolderDownload({
        id: uuidv4(),
        folderName: folder.display_name,
        folderId: folder?.folder_id,
        caseId: caseId,
        status: 'failed',
        error: error.message || 'Failed to initiate folder download',
      });
    }
  };

  return { downloadFile, downloadCertFile, downloadFolder };
}
